import React, { useState } from "react";
import MicroModal from "micromodal";
import { useSelector } from "react-redux";

import EditEvaluationModal from "../../../components/PlatformNps/Modals/EditEvaluationModal";
import RncModal from "../../../components/PlatformNps/Modals/RncModal";
import ReportModal from "../../../components/PlatformNps/Modals/ReportModal";
import Typography from "../../../components/Typography";
import UserHistory from "../../../components/NpsPage/Dealing/Drawer/UserHistory/UserHistory";
import UserHistoryCallCenter from "../../../components/QualityAgent/Dealing/Drawer/UserHistory/UserHistory";

import { ReactComponent as UserTagIcon } from "../../../build/images/nps-dashboard-icons/user-tag.svg";
import { ReactComponent as UserAddIcon } from "../../../build/images/nps-dashboard-icons/user-add.svg";
import { ReactComponent as ExportIcon } from "../../../build/images/nps-dashboard-icons/export.svg";

import "./search.css";
import ReportCallCenterModal from "../../../components/PlatformNps/Modals/ReportCallCenterModal";
import EditEvaluationCallCenterModal from "../../../components/PlatformNps/Modals/EditEvaluationCallCenterModal";
import RncCallCenterModal from "../../../components/PlatformNps/Modals/RncCallCenterModal";
import EditEvaluationCallCenterCSATModal from "../../../components/PlatformNps/Modals/EditEvaluationCallCenterCSATModal";

function returnedNameNps(note) {
  if (note <= 6) {
    return "Detrator";
  }

  if (note === 7 || note === 8) {
    return "Neutro";
  }

  if (note === 9 || note === 10) {
    return "Promotor";
  }
}

export default function Search({ children }) {
  const clientAnswerReducer = useSelector((state) => state.atendimento);
  const npsDetailsTotal = useSelector((state) => state.npsdetails);
  const npsDetailsReducer = npsDetailsTotal.filter(
    (nps) => nps.numero_cliente === clientAnswerReducer.telefone
  );
  const [userHistoryDrawer, setUserHistoryDrawer] = useState(false);
  const userReducer = useSelector((state) => state.informationusers);
  const userInformation = {
    profile:
      npsDetailsReducer.length !== 0
        ? returnedNameNps(npsDetailsReducer[0].nota_nps)
        : "",
    note: npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].nota_nps : "",
    attendance:
      npsDetailsReducer.length !== 0
        ? npsDetailsReducer[0].data_atendimento
        : "",
    unit: npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].unidade : "",
    datetime:
      npsDetailsReducer.length !== 0
        ? npsDetailsReducer[0].data_atendimento
        : "",
    phone:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].numero_cliente : "",
    serviceattid:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].id_atendimento : "",
    cdrid: npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].id_cdr : "",
    userid: userReducer.id,
    clientname:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].nome_cliente : "",
    isFromCallCenter:
      npsDetailsReducer.length !== 0
        ? npsDetailsReducer[0].isCallCenter
        : false,
    service: npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].service : "",
    isCSAT:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].isCSAT : false,
    conceito:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].conceito : "",
    cor_conceito:
      npsDetailsReducer.length !== 0
        ? npsDetailsReducer[0].cor_conceito
        : "#008908",
    nota_csat:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].nota_csat : "",
  };
  const isFromCallCenter =
    !!userInformation && userInformation.isFromCallCenter;

  //indica que as informações vieram do call center da aba de CSAT
  const isCSAT = isFromCallCenter && userInformation.isCSAT;

  return (
    <>
      {/* <section className="use-actions">
                <Typography.H4 weight="700" color="blue-selected-4">
                    Allan Kardec
                </Typography.H4>

                <div className="use-actions__icons">
                    <UserTagIcon />

                    <UserAddIcon />
                </div>
            </section> */}

      <section className="served-user-information">
        {isFromCallCenter ? (
          <Typography.H4 weight="700" color="black">
            Perfil:
            {isCSAT ? (
              <span
                className={`profile-detector-csat`}
                style={{
                  color: userInformation.cor_conceito,
                }}
              >
                {userInformation.conceito}
              </span>
            ) : (
              <span className={`profile-detector-${userInformation.profile}`}>
                {userInformation.profile}
              </span>
            )}
            <br />
            Nota:
            {isCSAT ? (
              <span
                className={`profile-detector-csat`}
                style={{
                  color: userInformation.cor_conceito,
                }}
              >
                {userInformation.nota_csat}
              </span>
            ) : (
              <span className={`profile-detector-${userInformation.profile}`}>
                {userInformation.note}
              </span>
            )}
            <br />
            Atendimento:
            <span className="served-user-information__span">
              {userInformation.attendance}
            </span>{" "}
            <br />
            Serviço:
            <span className="served-user-information__span">
              {userInformation.service}
            </span>{" "}
            <br />
            Telefone:
            <span className="served-user-information__span">
              {userInformation.phone}
            </span>
          </Typography.H4>
        ) : (
          <Typography.H4 weight="700" color="black">
            Perfil:
            <span className={`profile-detector-${userInformation.profile}`}>
              {userInformation.profile}
            </span>{" "}
            <br />
            Nota:
            <span className={`profile-detector-${userInformation.profile}`}>
              {userInformation.note}
            </span>{" "}
            <br />
            Atendimento:
            <span className="served-user-information__span">
              {userInformation.attendance}
            </span>{" "}
            <br />
            Unidade:
            <span className="served-user-information__span">
              {userInformation.unit}
            </span>{" "}
            <br />
            {/* Data e hora:
                    <span className="served-user-information__span">
                        {userInformation.datetime}
                    </span> <br /> */}
            Paciente:
            <span className="served-user-information__span">
              {userInformation.clientname}
            </span>
            <br />
            Telefone:
            <span className="served-user-information__span">
              {userInformation.phone}
            </span>
          </Typography.H4>
        )}
      </section>

      <section
        className="customer-reporting"
        onClick={() => MicroModal.show("modal-component-report-modal")}
      >
        <Typography.H4
          weight="700"
          color="blue-selected-4"
          className="customer-reporting__typography"
        >
          Reporte ao cliente
        </Typography.H4>

        <ExportIcon />
      </section>

      <section
        className="customer-history"
        onClick={() => setUserHistoryDrawer(true)}
      >
        <Typography.H4
          weight="700"
          color="blue-selected-4"
          className="customer-history__typography"
        >
          Histórico do cliente
        </Typography.H4>

        <ExportIcon />
      </section>

      <section
        className="edit-satisfaction-survey"
        onClick={() => MicroModal.show("modal-component-edit-evaluation-modal")}
      >
        <Typography.H4
          weight="700"
          color="blue-selected-4"
          className="edit-satisfaction-survey__typography"
        >
          Editar pesquisa de satisfação
        </Typography.H4>

        <ExportIcon />
      </section>

      <section
        className="rnc"
        onClick={() => MicroModal.show("modal-component-rnc-modal")}
      >
        <Typography.H4
          weight="700"
          color="blue-selected-4"
          className="rnc__typography"
        >
          RNC
        </Typography.H4>

        <ExportIcon />
      </section>

      {children}

      {userHistoryDrawer && isFromCallCenter ? (
        <div className="drawer-container">
          <UserHistoryCallCenter
            onSearch
            userHistoryDrawer={userHistoryDrawer}
            onCloseDrawer={() => setUserHistoryDrawer(false)}
            treatmentData={userInformation}
            interactionPhone={clientAnswerReducer.telefone}
            isCSAT={userInformation.isCSAT ? userInformation.isCSAT : false}
          />
        </div>
      ) : null}

      {userHistoryDrawer && !isFromCallCenter ? (
        <div className="drawer-container">
          <UserHistory
            onSearch
            userHistoryDrawer={userHistoryDrawer}
            onCloseDrawer={() => setUserHistoryDrawer(false)}
            treatmentData={userInformation}
            interactionPhone={clientAnswerReducer.telefone}
          />
        </div>
      ) : null}

      {isFromCallCenter ? (
        <ReportCallCenterModal
          modalTitle="Reporte ao cliente"
          data={userInformation}
        />
      ) : (
        <ReportModal modalTitle="Reporte ao cliente" data={userInformation} />
      )}
      {isFromCallCenter ? (
        <EditEvaluationCallCenterModal
          modalTitle="Editar pesquisa de satisfação"
          dataInfo={userInformation}
        />
      ) : (
        <EditEvaluationModal
          modalTitle="Editar pesquisa de satisfação"
          data={userInformation}
        />
      )}
      {isFromCallCenter ? (
        <RncCallCenterModal
          modalTitle="RNC (Não conformidade)"
          data={userInformation}
        />
      ) : (
        <RncModal modalTitle="RNC (Não conformidade)" data={userInformation} />
      )}
    </>
  );
}
